import CheckIcon from '@mui/icons-material/Check'
import { colors } from '@theme/variables'

import { CheckIconWrapper } from './index.styles'
import { CheckmarkInCircleIconProps } from './types'

const CheckmarkInCircleIcon = ({ isHighlighted, isSmall }: CheckmarkInCircleIconProps) => {
  return (
    <CheckIconWrapper $isSmall={!!isSmall}>
      <CheckIcon
        fontSize={isSmall ? 'small' : 'medium'}
        className="check-mark"
        htmlColor={isHighlighted ? colors.primary : '#EEEEEE'}
      />
    </CheckIconWrapper>
  )
}

export default CheckmarkInCircleIcon
